import React from 'react';

const CreditsHistory = () => {
  return <h1>CreditsHistory Page</h1>;
};

export default CreditsHistory;
